module.exports = __webpack_public_path__ + "static/EsperQuality-3d6c1cc2868caa6e82df84eec08f537f.svg";